module.exports = __webpack_public_path__ + "img/xhnk.6ddebb46.svg";